<template>
	<!-- 客户管理 -->
	<div class="saleCustomerManagement owner-examine-page">
		<div class="public_Spacing customerManagementPC owner-examine-shell">
			<div class="pulbic_oparetionBlock owner-filter-card">
				<div class="owner-section-head">
					<div>
						<div class="owner-section-title">行驶证审核</div>
						<div class="owner-section-subtitle">按所有人、手机号、车牌号筛选车辆审核信息</div>
					</div>
					<div class="owner-total-chip">共 {{ count || 0 }} 条</div>
				</div>
				<div class="public_criteriaRange customerManagementPC-select owner-filter-fields">
					<div class="public_oparetionBlock_Menu owner-filter-item">
						<label class="public_lbSty">行驶证所有人</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input class="el-input__inner pulic_carNumber" type="text" placeholder="请输入车主姓名"
									v-model="cusQueryName" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu owner-filter-item">
						<label class="public_lbSty">手机号</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input maxlength="11" class="el-input__inner pulic_carNumber" type="text"
									placeholder="请输入手机号" v-model="cusQueryiphone" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu owner-filter-item">
						<label class="public_lbSty">车牌号</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input maxlength="11" class="el-input__inner pulic_carNumber" type="text"
									placeholder="请输入车牌号" v-model="licensePlate" />
							</div>
						</div>
					</div>
				</div>
					<div class="customerManagementPC-btn public_operatBtn owner-filter-actions">
					
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList()">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
				</div>
			</div>
			<div class="customerManagementPC-table pulbic_table_container owner-table-card">
				<div class="owner-table-toolbar">
					<div>
						<div class="owner-section-title">审核列表</div>
						<div class="owner-section-subtitle">查看行驶证资料、驾驶证图片和审核状态</div>
					</div>
					<div class="owner-status-legend">
						<span><i class="owner-dot owner-dot-pending"></i>未审核</span>
						<span><i class="owner-dot owner-dot-pass"></i>通过</span>
						<span><i class="owner-dot owner-dot-reject"></i>拒绝</span>
					</div>
				</div>
				<el-table :data="tableData" tooltip-effect="dark" @sort-change="onSortChange" style="width: 100%" stripe highlight-current-row
					class="public_tableColumn owner-main-table" :header-cell-style="{color:'rgba(38,50,56,1)',background:'rgba(232,246,255,1)','font-weight':'bold'}">
					<el-table-column prop="ORMTB450CA06" label="行驶证所有人" min-width="210" fixed="left">
						<template slot-scope="scope">
							<div class="owner-name-cell">
								<span class="owner-avatar">{{ (scope.row.ORMTB450CA06 || '-').slice(0, 1) }}</span>
								<span class="owner-name">{{ scope.row.ORMTB450CA06 || '--' }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="ORMTB450CA07" label="手机号" min-width="140" show-overflow-tooltip>
						<template slot-scope="scope">
							<div class="owner-phone-list">
								<span v-for="(item, index) in scope.row.ORMTB450CA07" :key="index">{{ item.phone }}</span>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="ORMTB410CA02" label="手机号"></el-table-column> -->
					<el-table-column prop="ORMTB450CA03" label="车牌号" min-width="130">
						<template slot-scope="scope">
							<span class="owner-plate">{{ scope.row.ORMTB450CA03 || '--' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ORMTB450CA11" label="车辆注册时间" min-width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="ORMTB450CA05" label="行驶证类型" min-width="130">
						<template slot-scope="scope">
							<span class="owner-type-tag" v-if="scope.row.ORMTB450CA05 =='2'">公司（挂靠）</span>
							<span class="owner-type-tag" v-if="scope.row.ORMTB450CA05 =='0'">公司</span>
							<span class="owner-type-tag" v-if="scope.row.ORMTB450CA05 =='1'">本人</span>

						</template>
					</el-table-column>
					<el-table-column prop="ORMTB450CA00" label="车型" min-width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="ORMTB450CA13" label="使用性质" min-width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="ORMTB450CA12" label="总质量" min-width="110" show-overflow-tooltip></el-table-column>
					<el-table-column prop="ORMTB450CA14" label="初次领证日期" min-width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="ORMTB450CA15" label="有效截至日期" min-width="140" show-overflow-tooltip></el-table-column>
					<!-- <el-table-column prop="ORMTB450CA16" label="准驾车型"></el-table-column> -->
					<el-table-column prop="ORMTB450CA16" label="行驶证正面图片" width="140">
						<template slot-scope="scope">
							<div class="owner-image-preview">
								<el-image fit="cover" :src="scope.row.ORMTB450CA01" :preview-src-list="xsZsrcList"></el-image>
							</div>

						</template>
					</el-table-column>
					<el-table-column prop="ORMTB450CA02" label="行驶证背面图片" width="140">
						<template slot-scope="scope">
							<div class="owner-image-preview">
								<el-image fit="cover" :src="scope.row.ORMTB450CA02" :preview-src-list="xsFsrcList"></el-image>
							</div>

						</template>
					</el-table-column>
					<el-table-column prop="ORMTB450CA02" label="驾驶证图片" width="130">
						<template slot-scope="scope">
							<div class="owner-image-preview">
								<el-image fit="cover" :src="scope.row.ORMTB450CA08" :preview-src-list="jszsrcList"></el-image>
							</div>

						</template>
					</el-table-column>
					<el-table-column prop="ORMTB450CA10" label="审核状态" width="120">
						<template slot-scope="scope">
							<span class="owner-status-tag" :class="{
								'owner-status-pending': scope.row.ORMTB450CA10 == '0',
								'owner-status-pass': scope.row.ORMTB450CA10 == '1',
								'owner-status-reject': scope.row.ORMTB450CA10 == '2'
							}">
								{{ scope.row.ORMTB450CA10 == '0' ? '未审核' : scope.row.ORMTB450CA10 == '1' ? '通过' : scope.row.ORMTB450CA10 == '2' ? '拒绝' : '--' }}
							</span>

						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" width="210">
						<template slot-scope="scope">
							<div v-if="scope.row.ORMTB450CA10 =='0'||scope.row.ORMTB450CA10=='2'"
								class="customerManagementPC-table-btn owner-action-group">
								<el-button @click="updateUserStatus(scope.row)" type="success" class="owner-action-pass" size="small">通过</el-button>
								<el-button @click="updateUserJJStatus(scope.row)" type="danger" class="owner-action-reject" size="small">拒绝</el-button>
								<el-button v-if="scope.row.ORMTB450CA10 =='2'" @click="updateUserJJYYStatus(scope.row)" type="primary" class="owner-action-detail" size="small">详情</el-button>
							</div>
							<span v-else class="owner-pass-text">无需操作</span>
						</template>
					</el-table-column>
					<template slot="empty">
						<div class="owner-empty">
							<div class="owner-empty-title">暂无车辆审核数据</div>
							<div class="owner-empty-desc">可调整筛选条件后重新查询</div>
						</div>
					</template>
				</el-table>
				<div class="customerManagementPC-page owner-pagination">
					<span class="owner-total-text" v-if="flag =='1'">共{{count}}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>
			
			
		</div>
	</div>
</template>

<script>
	import {
		Decimal
	} from 'decimal.js';
	export default {
		data() {
			return {
				customerManagementList: '',
				customerManagementValue: '',
				customerManagement: false,
				customerManagementAdd: false,
				customerManagementAddName: '',
				customerManagemenUPObj: '',
				customerManagementUpdate: false,
				cusQueryName: '',
				cusQueryiphone: '',
				licensePlate:'',
				options: [],
				cusStatus: '',
				cusStatusList: [],
				tableData: [],
				flag: '',
				page: 1,
				pagesize: 10,
				currentPage: 1,
				count: 0,
				currentPage1: 1,
				detailsPageLimit: 10,
				detailsCount: 1,
				RechargetypeValue: '',
				RechargetypeOptions: [],
				CZRecordsDetails: [],
				CZRecordsPage: 1,
				CZRecordsPageLimit: 10,
				CZRecordsCount: 0,
				tableDataDetails: [],
				offerDetailsTab: [],
				ORMTB411ID: '',
				CustomerfillingDig: false,
				
				HCmoney: '',
				HCremark: '',
				HCamountCapitalText: '',
				amountCapitalText: '',
				cusInsertShow: false,
				cusInsertObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusUpdateShow: false,
				cusUpdateObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				saleWaterDetails: false,
				rechargeTypeDig: false,
				rechargeTypeName: '',
				rechargeTypeUpOBJ: {
					SETTB206CA01: ''
				},
				rechargeTypeModifyDig: false,
				czRechargetypeShow: false,
				HCshow: false,
				HCObj: '',
				preferentialRecord: false,
				offerDetails: false,
				DetailsWater: false,
				deductionRecord: false,
				deductionRecordObj: '',
				deductionRecordtable: [],
				deductionRecordPage: 1,
				deductionRecordLimit: 10,
				deductionRecordCount: 0,
			
				preferentialType: 0,
				solelist: [],
				xsZsrcList: [],
				xsFsrcList: [],
				jszsrcList: [],
			};
		},
		created() {
			var list = "";
			if (this.$route.query.mark != "" && this.$route.query.mark != null) {
				this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
				list = JSON.parse(sessionStorage.getItem("qpSolelist"));
				sessionStorage.removeItem('qpUobj');
				sessionStorage.removeItem('qpSolelist');
				this.quanpDisabled = true;
			} else {
				this.userobj = this.$store.state.uobj;
				list = this.$store.state.solelist;
				this.quanpDisabled = false;
			}
			var path = this.$route.path;
			if (path === "/SalesOwnerExamine") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			sessionStorage.removeItem(this.currentUrl);
			if (this.historyInfo != null && this.historyInfo != "") {
				this.init();
			}
			// console.log(this.solelist)
		},
		mounted() {
			this.querycusList()
			// this.querypreferentialCode()
		},
		// 存储数据
		beforeDestroy() {
			// var obj = {
			// 	cusQueryName: this.cusQueryName, //客户名称
			// 	cusQueryiphone: this.cusQueryiphone, //客户名称
			// 	cusStatus: this.cusStatus, //客户状态
			// 	currentPage: this.currentPage, //当前页数
			// 	page: this.page, //页码
			// 	pagesize: this.pagesize, //每页条数
			// };
			// sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
		},
		methods: {

			onSortChange({
				prop,
				order
			}) {
				// console.log(order)
				if (prop == 'ORMTB410CA06') {
					this.tableData.sort(this.compare(prop, order));
				}

			},
			compare(propertyName, sort) {
				return function(obj1, obj2) {
					var value1 = obj1[propertyName];
					var value2 = obj2[propertyName];
					// console.log(value2)

					if (typeof value1 === "string" && typeof value2 === "string") {
						const res = value1.localeCompare(value2);
						return sort === "ascending" ? res : -res;
					} else {
						// if (value1 <= value2) {
						// 	return sort === "ascending" ? -1 : 1;
						// } else if (value1 > value2) {
						// 	return sort === "ascending" ? 1 : -1;
						// }
					}
				};
			},


			//拒绝
			updateUserJJStatus(item) {
				var url = "/orm/ormtb450/updateORMTB450CA10"
				this.$prompt('请输入拒绝原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^.{1,}$/,
					inputErrorMessage: '原因不能为空'
				}).then(({
					value
				}) => {
					var postData = {
						ORMTB450CA10: 2,
						ORMTB450ID: item.ORMTB450ID,
						ORMTB450CA17: value
					}
					var loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.querycusList()
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					}).catch(() => {
						loading.close()
					})
				})
			},

			updateUserJJYYStatus(item) {
				// console.log(item)
				var url = "/orm/ormtb450/updateORMTB450CA10"
				this.$alert(item.ORMTB450CA17, '拒绝原因', {
					confirmButtonText: '确定',
					callback: action => {
					
					}
				});
			},
			// 通过
			updateUserStatus(item) {
				var url = "/orm/ormtb450/updateORMTB450CA10"

				// console.log(item)
				var postData = {
					ORMTB450CA10: 1,
					ORMTB450ID: item.ORMTB450ID
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})

			},


			//初始化数据
			init() {
				this.cusQueryName = this.historyInfo.cusQueryName;
				this.cusQueryiphone = this.historyInfo.cusQueryiphone;
				this.currentPage = this.historyInfo.currentPage;
				this.page = this.historyInfo.page;
				this.pagesize = this.historyInfo.pagesize;
				this.cusStatus = this.historyInfo.cusStatus
			},
			fullScreen() {
				//全屏
				var mark = 1;
				sessionStorage.setItem(
					"qpSolelist",
					JSON.stringify(this.$store.state.solelist)
				);
				sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

				let Logistics = this.$router.resolve({
					path: "/SalesCustomer",
					query: {
						mark: mark,
					},
				});
				this.$baseAPI.requestFullScreen(Logistics);
			},
			querycusList() {
				this.tableData = []
				var url = "/orm/ormtb450/selectPageList"

				var postData = {
					// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					ORMTB450CA06: this.cusQueryName, //客户名称
					ORMTB450CA07: this.cusQueryiphone, //手机号
					ORMTB450CA03: this.licensePlate, //车牌号
					page: this.page,
					limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data;
						this.count = res.data.count;
						this.tableData.forEach((item) => {
							this.xsZsrcList.push(item.ORMTB450CA01);
							this.xsFsrcList.push(item.ORMTB450CA02);
							this.jszsrcList.push(item.ORMTB450CA08);
						});
					}
					if (this.tableData.length > 0) {
						setTimeout(() => {
							loading.close()
						}, 300)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)

				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
				this.page = 1;
				this.querycusList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.querycusList();
			},
			
			deductionRecordClick(row) {
				this.deductionRecordtable = []
				// this.deductionRecordCount=0
				var url = "/orm/ormtb413/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.ORMTB411ID = row.ORMTB411ID
				var postData = {
					ORMTB411ID: this.ORMTB411ID,
					page: this.deductionRecordPage,
					limit: this.deductionRecordLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.deductionRecordtable = res.data.data;
						this.deductionRecordCount = res.data.count
						this.deductionRecordtable.forEach(item => {
							if (item.ORMTB413CA02 == 'KK') {
								item.ORMTB413CA02Text = "扣款"
							} else if (item.ORMTB413CA02 == 'TK') {
								item.ORMTB413CA02Text = "退款"
							}
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			deductionRecordSizeChange(val) {
				this.deductionRecordLimit = val;
				this.deductionRecordPage = 1;
				this.deductionRecordClick();
			},
			deductionRecordCurrentChange(val) {
				this.deductionRecordPage = val;
				this.deductionRecordClick();
			},
			queryWayTypeQuery() {
				this.tableDataDetails = []
				// this.detailsCount=0
				var url = "/set/settb206/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
					SETTB205ID: '01',
					page: this.currentPage1,
					limit: this.detailsPageLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableDataDetails = res.data.data;
						this.detailsCount = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange1(val) {
				this.detailsPageLimit = val;
				this.currentPage1 = 1;
				this.deductionRecordClick();
			},
			handleCurrentChange1(val) {
				this.currentPage1 = val;
				this.deductionRecordClick();
			},
			cusInsertClose() {
				this.cusInsertObj = {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				}
			},
			
			
			
			upuserClick(row) {
				if (this.preferentialType == 1) {
					this.customerManagementQuery()
				}
				this.cusUpdateShow = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
			},
			
			
			rechargeTypeModify(row) {
				this.rechargeTypeModifyDig = true
				var str = JSON.stringify(row)
				this.rechargeTypeUpOBJ = JSON.parse(str)
			},
			
			rechargeTypeAdd() {
				this.rechargeTypeDig = true
			},
			rechargeTypeModifyClose() {
				this.rechargeTypeUpOBJ = {
					SETTB206CA01: ''
				}
			},
			querypreferentialCode() {
				var url = "/set/settb206/selectSETTB206List "
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					"SETTB205ID": "02", //默认02
					"SETTB206CA00": "0202", //代码值默认0202
					"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.preferentialType = res.data.data[0].SETTB206CA02
						// 	loading.close()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			customerManagementQuery() {
				this.customerManagementList = []
				var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.customerManagementList = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			customerManagementAddServe() {
				if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/set/settb206/insertVIP "
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.customerManagementAddName,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.customerManagementQuery()
						this.customerManagementAdd = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusUpdataClick(row) {
				this.customerManagemenUPObj = row
				this.customerManagemenUPObj.oldname = row.SETTB206CA01
				this.customerManagementUpdate = true
			},
			customerManagementUpdateServe() {
				if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01)
					return this.$message
						.error('请修改名称')
				if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error(
					'请输入名称')
				var url = "/set/settb206/updateVIP"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
					SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.customerManagementQuery()
						this.customerManagementUpdate = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechaTypePreser() {
				if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/orm/ormtb410/addCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.rechargeTypeName,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.queryWayTypeQuery()
						this.rechargeTypeDig = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			
			
		}
	};
</script>

<style scoped>
	.owner-examine-page {
		min-height: 100%;
		padding: 12px;
		box-sizing: border-box;
		background:
			radial-gradient(circle at 8% 0%, rgba(25, 159, 255, 0.12), transparent 28%),
			linear-gradient(180deg, #eef7ff 0%, #f6f8fb 48%, #f3f6fa 100%);
		color: #263238;
	}

	.owner-examine-shell {
		background: transparent;
	}

	.owner-filter-card,
	.owner-table-card {
		border: 1px solid rgba(190, 218, 238, 0.72);
		border-radius: 16px;
		background: rgba(255, 255, 255, 0.96);
		box-shadow: 0 12px 32px rgba(30, 86, 130, 0.08);
	}

	.owner-filter-card {
		margin-bottom: 10px;
		padding: 14px 16px;
	}

	.owner-section-head,
	.owner-table-toolbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 14px;
		margin-bottom: 12px;
	}

	.owner-section-title {
		position: relative;
		padding-left: 12px;
		color: #1f3a4a;
		font-size: 18px;
		font-weight: 700;
		line-height: 24px;
	}

	.owner-section-title::before {
		content: '';
		position: absolute;
		left: 0;
		top: 5px;
		width: 4px;
		height: 14px;
		border-radius: 4px;
		background: linear-gradient(180deg, #199fff, #20da9c);
	}

	.owner-section-subtitle {
		margin-top: 3px;
		padding-left: 12px;
		color: #7b8c98;
		font-size: 12px;
	}

	.owner-total-chip {
		min-width: 92px;
		padding: 7px 14px;
		border-radius: 16px;
		background: #eef8ff;
		color: #0f7fc5;
		text-align: center;
		font-size: 13px;
		font-weight: 700;
	}

	.owner-filter-fields {
		display: grid;
		grid-template-columns: repeat(3, minmax(170px, 1fr));
		gap: 12px 16px;
		align-items: end;
		width: 100%;
	}

	.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
		margin-left: 0;
	}

	.owner-examine-page .owner-filter-item {
		display: block;
		height: auto;
		margin: 0;
	}

	.owner-filter-item .public_lbSty {
		display: block;
		margin-bottom: 7px;
		color: #516674;
		font-size: 13px;
		font-weight: 700;
		line-height: 18px;
	}

	.owner-filter-item .public_optionSty,
	.owner-filter-item .el-select,
	.owner-filter-item .el-input {
		width: 100% !important;
	}

	.owner-filter-item .pulic_carNumber {
		width: 100%;
		margin-top: 0;
		border-color: #d9e7f0;
		border-radius: 10px;
		background: #fbfdff;
		color: #263238;
	}

	.owner-filter-actions {
		display: flex;
		justify-content: flex-end;
		margin: 12px 0 0;
		text-align: right;
	}

	.owner-query-btn {
		min-width: 96px;
		height: 36px;
		border-color: #199fff;
		border-radius: 10px;
		background: linear-gradient(135deg, #199fff, #12aee5);
		box-shadow: 0 8px 18px rgba(25, 159, 255, 0.22);
		font-weight: 700;
	}

	.owner-query-btn i,
	.customerManagementPC-btn i {
		margin-right: 8px;
	}

	.owner-table-card {
		padding: 16px 16px 0;
	}

	.owner-status-legend {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 8px 12px;
		border-radius: 14px;
		background: #f6fbff;
		color: #607481;
		font-size: 12px;
	}

	.owner-status-legend span,
	.owner-name-cell,
	.owner-phone-list,
	.owner-action-group {
		display: flex;
		align-items: center;
	}

	.owner-dot {
		display: inline-block;
		width: 7px;
		height: 7px;
		margin-right: 6px;
		border-radius: 50%;
	}

	.owner-dot-pending {
		background: #f0a31a;
	}

	.owner-dot-pass {
		background: #20b486;
	}

	.owner-dot-reject {
		background: #ef6b6b;
	}

	.owner-name-cell {
		justify-content: flex-start;
		gap: 8px;
		text-align: left;
	}

	.owner-avatar {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 28px;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: linear-gradient(135deg, #199fff, #20da9c);
		color: #fff;
		font-size: 13px;
		font-weight: 700;
	}

	.owner-name {
		flex: 1;
		min-width: 0;
		color: #304653;
		font-weight: 700;
		line-height: 20px;
		white-space: normal;
		word-break: break-all;
	}

	.owner-phone-list {
		justify-content: center;
		flex-direction: column;
		gap: 3px;
		color: #455a64;
	}

	.owner-plate {
		display: inline-block;
		min-width: 78px;
		padding: 4px 10px;
		border: 1px solid #cfe7f6;
		border-radius: 8px;
		background: #f3fbff;
		color: #0f7fc5;
		font-weight: 700;
	}

	.owner-type-tag,
	.owner-status-tag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 72px;
		height: 26px;
		padding: 0 10px;
		border-radius: 13px;
		box-sizing: border-box;
		font-size: 12px;
		font-weight: 700;
	}

	.owner-type-tag {
		background: #eef8ff;
		color: #0f7fc5;
	}

	.owner-status-pending {
		background: #fff6e8;
		color: #d8840d;
	}

	.owner-status-pass {
		background: #e9faf4;
		color: #10a777;
	}

	.owner-status-reject {
		background: #fff0f0;
		color: #df4d4d;
	}

	.owner-image-preview {
		display: flex;
		justify-content: center;
	}

	.owner-image-preview .el-image {
		width: 52px;
		height: 52px;
		border: 1px solid #dceaf2;
		border-radius: 10px;
		box-shadow: 0 6px 14px rgba(31, 80, 112, 0.1);
	}

	.owner-action-group {
		justify-content: center;
		gap: 6px;
	}

	.owner-action-group .el-button {
		min-width: 48px;
		margin-left: 0;
		border-radius: 8px;
		font-weight: 700;
	}

	.owner-action-pass {
		color: #20a778 !important;
		background: #ecfbf6 !important;
		border-color: #bcebdc !important;
	}

	.owner-action-reject {
		color: #df4d4d !important;
		background: #fff0f0 !important;
		border-color: #ffd0d0 !important;
	}

	.owner-action-detail {
		color: #0f7fc5 !important;
		background: #eef8ff !important;
		border-color: #cbe7f8 !important;
	}

	.owner-pass-text {
		color: #9aacb7;
		font-size: 12px;
	}

	.owner-empty {
		padding: 42px 0;
		text-align: center;
	}

	.owner-empty-title {
		color: #334955;
		font-size: 16px;
		font-weight: 700;
	}

	.owner-empty-desc {
		margin-top: 8px;
		color: #8fa1ad;
		font-size: 13px;
	}

	.owner-pagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 0;
		padding: 16px 0 18px;
		text-align: right;
	}

	.owner-total-text {
		color: #606266;
		font-size: 14px;
	}

	.customerManagementPC-table-btn i {
		font-size: 12px;
		margin-right: 5px;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center;
	}

	.el-dropdown-link {
		cursor: pointer;
	}

	.el-table--scrollable-y .el-table__body-wrapper {
		overflow: auto;
	}

	.public_tableColumn .el-table__body-wrapper {
		overflow: auto !important;
	}

	.public_icon_width {
		width: 80px;
	}

	::v-deep .owner-filter-card .el-input__inner {
		height: 36px;
		border-color: #d9e7f0;
		border-radius: 10px;
		background: #fbfdff;
		line-height: 36px;
	}

	::v-deep .owner-filter-card .el-input__inner:focus {
		border-color: #199fff;
		box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
	}

	::v-deep .owner-main-table {
		border-radius: 12px;
		overflow: hidden;
	}

	::v-deep .owner-main-table .el-table__header th {
		height: 46px;
	}

	::v-deep .owner-main-table .el-table__row td {
		height: 58px;
		color: #455a64;
	}

	::v-deep .owner-main-table .el-table__row:hover > td {
		background-color: #f0f9ff !important;
	}

	::v-deep .owner-pagination .el-pagination__total,
	::v-deep .owner-pagination .el-pagination__jump {
		color: #647783;
	}

	::v-deep .owner-pagination .el-pager li.active {
		border-radius: 6px;
		background: #199fff;
		color: #fff;
	}

	@media (max-width: 1200px) {
		.owner-filter-fields {
			grid-template-columns: repeat(2, minmax(180px, 1fr));
		}
	}

	@media (max-width: 760px) {
		.owner-examine-page {
			padding: 10px;
		}

		.owner-section-head,
		.owner-table-toolbar,
		.owner-status-legend {
			align-items: flex-start;
			flex-direction: column;
		}

		.owner-filter-fields {
			grid-template-columns: 1fr;
		}
	}
</style>
